import { useTranslation } from "react-i18next";
import useGet from "src/hooks/rest/useGet";
import useAuth from "src/hooks/selectors/useAuth";
import FlatList from "src/components/FlatList";
import TaskCard from "src/components/tasks/TaskCard";
import useTenant from "src/hooks/api/services/tenants/useTenant";

interface TasksGridProps {
	q: string;
	searchActions?: any;
}

const TasksGrid = ({ q, searchActions }: TasksGridProps) => {
	const { t } = useTranslation("tasks", {
		keyPrefix: "tasks-grid",
	});
	const auth = useAuth();
	const type = auth.type;
	const [{ data, hasMore }, loading, { fetchNext, handleSearch }] = useGet(
		`/${type}/tasks?limit=8&${q}`,
		{
			data: [],
		},
		true
	);
	const { tenant } = useTenant();
	const texts = {
		title: t("empty.title"),
		text: t("empty.text"),
		href: tenant?.urls?.public + "/tasks/all/everywhere",
	};

	const renderHeader = () => {
		return (
			<a
				className="text-white bg-dark rounded-md flex gap-4 justify-center items-center gtm-student-dashboard-mijn-opdrachten--button-opdrachten-zoeken"
				href={tenant?.urls?.public + "/tasks/all/everywhere"}
			>
				<i className="fas fa-search"></i>
				<p className="font-bold">{t("header.search")}</p>
			</a>
		);
	};

	return (
		<>
			<FlatList.Head
				title={t(`head.${auth.type}.title`)}
				subtitle={t(`head.${auth.type}.subtitle`)}
				search={{
					onSearch: handleSearch,
				}}
			>
				{searchActions}
			</FlatList.Head>

			<FlatList
				empty={texts as any}
				header={renderHeader()}
				columns={2}
				{...{ hasMore, data, loading }}
				onNext={async () => await fetchNext()}
				renderItem={(item) => {
					return (
						<TaskCard
							variant="large"
							key={`task-list-${item.id}`}
							registration={item}
							task={
								type === "student"
									? {
											...item.task,
											is_denied: item.is_denied,
											is_accepted: item.is_accepted,
											unread_messages:
												item?.unread_messages,
											is_signed: item?.is_signed,
									  }
									: item
							}
						/>
					);
				}}
			/>
		</>
	);
};

export default TasksGrid;
